/**
 * @module
 */
var constants = require('./constants');
var DirectiveStore = require('../di').get('stores/directive');

exports.domReadyTime = null;

/**
 * Kick off dom ready listeners
 *
 */
exports.initialize = function() {
  attemptToSetDomReady();
  document.addEventListener('readystatechange', attemptToSetDomReady, true);
};

/**
 * Determines whether polling is timed out based upon its start time, domready, and
 * the max polling interval.
 *
 * Currently, polling should be canceled at either 2 seconds after dom ready, or 2 seconds
 * after the polling start time, whichever comes last.
 *
 * If were running in the editor, we should always be timed out 2 seconds after dom ready.
 * @param {number} startTime
 *
 * @returns {boolean}
 */
exports.isTimedOut = function(startTime:number): boolean {
  var currentTime = Date.now();
  // If dom is not ready or we haven't started applying a change, we are not timed out
  if (!exports.domReadyTime || !startTime) {
    return false;
  }

  // Check to see if we've exceeded the max timeout
  var timeoutTime = Math.max(startTime, exports.domReadyTime);
  if (DirectiveStore.isEditor()) {
    timeoutTime = exports.domReadyTime;
  }
  return !(currentTime - timeoutTime < constants.SELECTOR_POLLING_MAX_TIME);
};


/**
 * Initialize the domready timestamp if the dom is indeed ready
 * @private
 */
function attemptToSetDomReady() {
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    exports.domReadyTime = Date.now();
  }
}
